import { InformationCircleIcon, NewspaperIcon, UserIcon } from '@heroicons/react/24/outline';
import { MdOutlineCategory, MdOutlineEventAvailable, MdOutlineEventNote } from 'react-icons/md';

import { IconNames } from 'components/Icon/Icon';
import { BsCardChecklist, BsPersonVcard } from 'react-icons/bs';
import { BiSolidSchool } from 'react-icons/bi';
import { GrMapLocation } from 'react-icons/gr';
import { TbList } from 'react-icons/tb';

export type IMenuChild = {
  id: string;
  label: string;
  Icon: any;
  disableBoard?: boolean;
  add?: boolean;
  addRightType?: string;
  addRightKey?: string;
  addRightKeyJoker?: string[];
  useWordingPlural?: boolean;
  isReservedForJuloa?: boolean;
};
export type IMenuGroup = {
  label: string;
  children: IMenuChild[];
  icon: IconNames;
  useWordingPlural?: boolean;
  isReservedForJuloa?: boolean;
};

export type IMenuConf = Record<string, IMenuGroup>;

/** ******************************** Sections ******************************* */

const followSection: IMenuConf = {
  // suivi
  suivi: {
    label: 'monitoring',
    icon: 'MdOutlineChecklist',
    children: [
      /*       {
        id: 'dashboard',
        label: 'board',
        Icon: TbLayoutDashboard,
        disableBoard: true,
      }, */
      {
        id: 'planning',
        label: 'myMeetings',
        Icon: MdOutlineEventNote,
        add: false,
        addRightKeyJoker: ['isAdmin'],
      },
      {
        id: 'availability',
        label: 'availability',
        Icon: MdOutlineEventAvailable,
        add: false,
        addRightKeyJoker: ['isAdmin'],
      },
    ],
  },
};

const publicationSection: IMenuConf = {
  gestion: {
    label: 'manage',
    icon: 'MdOutlineChecklist',
    children: [
      {
        id: 'contents',
        label: 'contents',
        Icon: NewspaperIcon,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
      {
        id: 'questions',
        label: 'faq',
        Icon: BsCardChecklist,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
    ],
  },
};

const ProUserManagementSection: IMenuConf = {
  userManagement: {
    label: 'userManagement',
    icon: 'MdOutlineChecklist',
    children: [
      {
        id: 'students',
        label: 'students',
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
    ],
  },
};

const AdminUserManagementSection: IMenuConf = {
  userManagement: {
    label: 'userManagement',
    icon: 'MdOutlineChecklist',
    children: [
      {
        id: 'students',
        label: 'students',
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
      {
        id: 'mediators',
        label: 'mediators',
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
      {
        id: 'users',
        label: 'users',
        Icon: BsPersonVcard,
        add: true,
        addRightKeyJoker: ['isAdmin'],
      },
    ],
  },
};

const mySpaceSection: IMenuChild[] = [
  {
    id: 'my-account-edit',
    label: 'myAccount',
    Icon: UserIcon,
  },
];

// const usersSection = {
//   id: "users",
//   label: "users",
//   Icon: UsersIcon,
//   add: true,
//   addRightType: "role",
//   addRightKey: "isAdmin",
// };

const adminUsersSection: IMenuChild[] = [
  {
    id: 'categories',
    label: 'categories',
    Icon: MdOutlineCategory,
    add: false,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'reasons',
    label: 'reasons',
    Icon: TbList,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'establishments',
    label: 'establishments',
    Icon: BiSolidSchool,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'departments',
    label: 'departments',
    Icon: GrMapLocation,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
];

const juloaAdminUsersSection: IMenuChild[] = [
  {
    id: 'categories',
    label: 'categories',
    Icon: MdOutlineCategory,
    add: false,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'reasons',
    label: 'reasons',
    Icon: TbList,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'establishments',
    label: 'establishments',
    Icon: BiSolidSchool,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
  {
    id: 'departments',
    label: 'departments',
    Icon: GrMapLocation,
    add: true,
    addRightKeyJoker: ['isAdmin'],
  },
  /* {
    id: 'configuration',
    label: 'configuration',
    Icon: IoSettingsOutline,
    add: false,
    addRightKeyJoker: ['isAdmin'],
  }, */
];

/** **********************************  Menus by roles ************************** */

export const proMenuNoProfile: IMenuConf = {
  informations: {
    label: 'information',
    icon: 'InformationCircleIcon',
    children: [
      {
        id: 'no-profile',
        label: 'noProfile',
        Icon: InformationCircleIcon,
      },
    ],
  },
  reglages: {
    label: 'params',
    icon: 'IoSettingsOutline',
    children: [...mySpaceSection],
  },
};

export const proMenu: IMenuConf = {
  ...followSection,
  ...publicationSection,
  ...ProUserManagementSection,
  reglages: {
    label: 'params',
    icon: 'IoSettingsOutline',
    children: [...mySpaceSection],
  },
};

export const adminMenu: IMenuConf = {
  ...followSection,
  ...publicationSection,
  ...AdminUserManagementSection,
  reglages: {
    label: 'params',
    icon: 'IoSettingsOutline',
    children: [...adminUsersSection, ...mySpaceSection],
  },
};

export const juloaAdminMenu: IMenuConf = {
  ...followSection,
  ...publicationSection,
  ...AdminUserManagementSection,
  reglages: {
    label: 'params',
    icon: 'IoSettingsOutline',
    children: [...juloaAdminUsersSection, ...mySpaceSection],
  },
};
